module.exports = __webpack_public_path__ + "img/celebrate.38ecbd80.svg";